<template>
  <el-row>
    <el-col :span="24">
      <rabbey-table-3
        :loading="loading"
        :columns="columns"
        :data="items"
        :paginate-from-api="true"
        :pagination-api="pagination"
        @update-current-page="onCurrentChange"
        @update-page-size="onSizeChange"
      >
      </rabbey-table-3>
    </el-col>
  </el-row>
</template>

<script>
const ACC_TYPES = {
  income: 4,
  costs: 5,
  expenses: 6,
  active: 1,
  passives: 2,
  capital: 3
};

export default {
  name: "AccountTabTable",

  props: {
    activeTab: {
      type: String,
      require: true,
      validator: (v) => {
        return ACC_TYPES[v] !== undefined;
      }
    },
    columns: {
      type: Array,
      require: true,
      default: () => []
    },
    year: {
      type: Number,
      required: true
    },
    month: {
      type: Number,
      required: true
    },
    search: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      loading: false,
      items: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    };
  },

  computed: {
    accType() {
      return ACC_TYPES[this.activeTab];
    },

    dataParams() {
      return {
        search: this.search,
        month: this.month,
        Company: this.currentCompany,
        Year: this.year,
        AccType: this.accType,
        PageSize: this.pagination.pageSize,
        CurrentPage: this.pagination.currentPage
      };
    }
  },

  created() {
    this.getData();
  },

  watch: {
    activeTab() {
      this.refreshData();
    }
  },

  methods: {
    getData() {
      return new Promise((resolve, reject) => {
        this.loading = true;
        this.$http
          .get(
            "/api/Generalledger/GetAccountAccount",
            {
              params: this.dataParams
            },
            { timeout: 5 * 60 * 1000 }
          )
          .then(({ data }) => {
            const { CountItems, Items } = data;

            this.pagination.total = CountItems;
            this.items = Items;

            resolve();
          })
          .catch((error) => {
            this.$message.error(error.data.Message);
            reject(error);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    refreshData() {
      if (this.loading === false) {
        this.getData();
      }
    },

    onCurrentChange(val) {
      this.pagination.currentPage = val;
      this.refreshData();
    },

    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.refreshData();
    }
  }
};
</script>
